export enum SocketEventTypesEnum {
  REFRESH_NOTIFICATIONS = 'REFRESH_NOTIFICATIONS',
}
